import { useEffect } from 'react';

export const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    document.title = title ? `${title} | Yembo` : 'Yembo';

    return () => {
      document.title = 'Yembo';
    };
  }, [title]);
};
